import React from "react";

type Step = { title: string; description: string };

type BookingStepsProps = {
  eyebrow: string;
  title: string;
  steps: Step[];
};

/** Numbered steps joined by a gradient line, as on the Work and Stay pages. */
export default function BookingSteps({ eyebrow, title, steps }: BookingStepsProps) {
  // The connector runs between the centres of the first and last circles
  const inset = `${50 / steps.length}%`;
  const columns = steps.length === 5 ? "lg:grid-cols-5" : "lg:grid-cols-4";

  return (
    <section className="bg-[#f8fbff] py-20">
      <div className="mx-auto max-w-[1440px] px-[16px] sm:px-8">
        <p className="text-center text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">
          {eyebrow}
        </p>
        <h2 className="pt-[12px] text-center text-[30px] font-bold leading-10 tracking-[-0.9px] text-[#0a0a0a] sm:text-[36px]">
          {title}
        </h2>

        <div className="relative pt-14">
          <div
            className="absolute top-[92px] hidden h-px lg:block"
            style={{ left: inset, right: inset, backgroundImage: "linear-gradient(90deg, #017bef 0%, #0062c0 100%)" }}
          />
          <div className={`grid grid-cols-1 gap-10 sm:grid-cols-2 lg:gap-0 ${columns}`}>
            {steps.map((step, index) => (
              <div key={step.title} className="relative flex flex-col items-center px-[16px] text-center lg:px-6">
                <div className="mb-[20px] flex size-[72px] items-center justify-center rounded-full border-4 border-solid border-white bg-[#017bef] text-[14px] font-bold leading-5 text-white drop-shadow-[0_4px_8px_rgba(1,123,239,0.25)]">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <h3 className="pb-2 text-[18px] font-bold leading-[27px] text-[#0a0a0a]">{step.title}</h3>
                <p className="max-w-[297px] text-[14px] leading-[22.75px] text-[#717182]">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
